export enum JobTypeEnum {
    '00' = 'AR',
    '01' = 'TRAD',
    '02' = 'DIG',
    '03' = 'FL',
    '04' = 'MO'
}